import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { AuthRealmService } from "../services/keycloak/auth-realm.service";

export const roleGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthRealmService); 

  const requiredRoles = route.data["roles"];

  if (!requiredRoles || requiredRoles.length === 0) {
    return true; // No roles required, allow access
  }

  // Check if the user has at least one of the required roles
  const hasAccess = requiredRoles.some((role: string) => authService.hasRole(role));

  if (!hasAccess) {
    router.navigate(["/"]);
    return false;
  }

  return true;
};
